import { DesktopOutlined, MobileOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

export const ColoredTags_predefinedTags = [
  { label: 'Fantasy', value: 'fantasy', color: 'green' },
  // { label: 'Эпическое фэнтези', value: 'high-fantasy', color: 'purple' },
  // { label: 'Тёмное фэнтези', value: 'dark-fantasy', color: 'magenta' },
  // { label: 'Героическое фэнтези', value: 'heroic-fantasy', color: 'volcano' },
  // { label: 'Низкое фэнтези', value: 'low-fantasy', color: 'geekblue' },
  // { label: 'Космоопера', value: 'space-opera', color: 'cyan' },

  //
  { label: 'Sci-Fi', value: 'sci-fi', color: 'blue' },
  // { label: 'Sci-Fi: Милитари', value: 'military-sci-fi', color: 'gold' },
  // { label: 'Sci-Fi: Grimdark', value: 'grimdark-sci-fi', color: 'lime' },
  // { label: 'Sci-Fi: Киберпанк', value: 'cyberpunk-postapoc', color: 'orange' },
  // ...добавьте свои теги по необходимости...

  { label: 'SCP', value: 'scp', color: 'cyan' },
  {
    label: (
      <>
        <DesktopOutlined /> Long
      </>
    ),
    value: 'long',
    color: 'blue',
  },
  {
    label: (
      <>
        <MobileOutlined /> Shorts
      </>
    ),
    value: 'short',
    color: 'red',
  },
];

export const ColoredTags = ({ tags }: { tags: string[] }) => {
  return (
    <>
      {tags.map((tag, index) => (
        <Tag key={tag} color={ColoredTags_predefinedTags.find(t => t.value === tag)?.color}>
          {tag}
        </Tag>
      ))}
    </>
  );
};
